"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _Group = require("../Group");

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

var _Error = _interopRequireDefault(require("../Error"));

var _Flex = _interopRequireDefault(require("../../../Layout/Flex"));

var _Hint = _interopRequireDefault(require("../Hint"));

var _Input = _interopRequireDefault(require("../Input"));

var _Label = _interopRequireDefault(require("../Label"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var InlineField = function InlineField(_a) {
  var component = _a.component,
      error = _a.error,
      id = _a.id,
      label = _a.label,
      name = _a.name,
      props = (0, _tslib.__rest)(_a, ["component", "error", "id", "label", "name"]);
  var isInGroup = (0, _react.useContext)(_Group.GroupContext).inGroup;
  return _react.default.createElement(_Flex.default, {
    className: props.className,
    "data-test": "inline-field",
    flexDirection: "column",
    mr: isInGroup ? 1 : 4,
    my: isInGroup ? 1 : 4
  }, !isInGroup && _react.default.createElement(_formik.ErrorMessage, {
    component: _Error.default,
    "data-testid": "validation__" + name,
    name: name
  }), _react.default.createElement(_formik.Field, (0, _tslib.__assign)({
    component: component,
    id: id,
    label: label,
    name: name
  }, props)));
};

var StackedField = function StackedField(_a) {
  var component = _a.component,
      error = _a.error,
      hint = _a.hint,
      id = _a.id,
      label = _a.label,
      name = _a.name,
      props = (0, _tslib.__rest)(_a, ["component", "error", "hint", "id", "label", "name"]);
  return _react.default.createElement(_Flex.default, {
    "data-test": "stacked-field",
    flexDirection: "column",
    justifyContent: "flex-start",
    my: 4
  }, _react.default.createElement(_Box.default, {
    as: "label",
    htmlFor: id
  }, _react.default.createElement(_Label.default, {
    as: "span",
    "data-testid": "label__" + name,
    pb: 1
  }, label), hint && _react.default.createElement(_Hint.default, {
    "data-testid": "hint__" + name,
    pb: 1
  }, hint), _react.default.createElement(_formik.ErrorMessage, {
    component: _Error.default,
    "data-testid": "validation__" + name,
    name: name
  })), _react.default.createElement(_Box.default, {
    pt: 1
  }, _react.default.createElement(_formik.Field, (0, _tslib.__assign)({
    component: component,
    "data-testid": "field__" + name,
    id: id,
    name: name
  }, props))));
};

var Field = function Field(_a) {
  var inline = _a.inline,
      props = (0, _tslib.__rest)(_a, ["inline"]);
  return inline ? _react.default.createElement(InlineField, (0, _tslib.__assign)({}, props)) : _react.default.createElement(StackedField, (0, _tslib.__assign)({}, props));
};

Field.displayName = 'Field';
Field.defaultProps = {
  component: _Input.default.Text,
  inline: false
};
var _default = Field;
exports.default = _default;